import { Stack } from "@mui/material";
import Select from "components/select/Select";
import { ALL_OPTION } from "constant";
import { useEffect } from "react";
import { useGetListProvinceType } from "service/query/common.query";
import { useGetListExtensionContactCenter } from "service/query/extension.query";

/** lưu thành typeProvince, code trong formik */
const SelectProvinceType = ({ formik }) => {
  const { data: listProvinceType } = useGetListProvinceType();
  const { data: listExtensionContactCenter } = useGetListExtensionContactCenter(
    {
      typeProvince: formik.values.typeProvince,
    },
    { enabled: !!formik.values.typeProvince }
  );

  useEffect(() => {
    if (listProvinceType && listProvinceType.length > 0) {
      formik.setFieldValue("typeProvince", listProvinceType[0].code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listProvinceType]);

  useEffect(() => {
    (async () => {
      if (listExtensionContactCenter && listExtensionContactCenter.length > 0) {
        if (listExtensionContactCenter.length === 1) {
          await formik.setFieldValue("code", [
            listExtensionContactCenter[0].code,
          ]);
          await formik.setFieldValue("contactCenters", [
            listExtensionContactCenter[0],
          ]);
        }

        if (listExtensionContactCenter.length > 1) {
          await formik.setFieldValue("code", [ALL_OPTION.value]);
          await formik.setFieldValue(
            "contactCenters",
            listExtensionContactCenter
          );
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listExtensionContactCenter]);

  return (
    <Stack spacing={2} direction="row">
      <Select
        label="Loại tổng đài"
        value={formik.values.typeProvince}
        onChange={async (value) => {
          await formik.setFieldValue("typeProvince", value);
        }}
        options={listProvinceType?.map((item) => ({
          value: item.code,
          label: item.name,
        }))}
        error={formik.touched.typeProvince && formik.errors.typeProvince}
      />

      <Select
        isMulti
        label="Đơn vị"
        onChange={async (value) => {
          await formik.setFieldValue("code", value);
          await formik.setFieldValue(
            "contactCenters",
            value.includes(ALL_OPTION.value)
              ? []
              : listExtensionContactCenter?.filter((item) =>
                  value.includes(item.code)
                )
          );
        }}
        showAllOption={
          listExtensionContactCenter && listExtensionContactCenter.length > 1
        }
        value={formik.values.code}
        options={listExtensionContactCenter?.map((item) => ({
          value: item.code,
          label: item.name,
        }))}
        error={formik.touched.code && formik.errors.code}
      />
    </Stack>
  );
};

export default SelectProvinceType;
